import { ADMIN_PERMISSIONS, adminRoleList, USER_ROLE } from "../../../../constants"
import {
  AssetRegistryIcon,
  DailyTrendsIcon,
  PlaylistIcon,
  RegistrationsIcon,
  ReleaseSubmissionIcon,
  ReleaseUpcIcon,
  ReportsApprovalIcon,
  UserAdvanceIcon,
  UserTakedownIcon,
  State51DeliveryIcon,
  RoyaltyReportsIcon,
  SchedulerLogsIcon,
  InsightsIcon,
  TerritoryDSPListIcon,
  UserAssetIcon,
  ActionsIcon,
  AnnouncementsIcon,
  MarketingIcon,
  SpotifyChartIcon
} from "../../../ui/icons"

export const adminNavElements = [
  {
    name: "Actions",
    href: "/actions",
    icon: ActionsIcon,
    permittedPermissions: [
      ADMIN_PERMISSIONS.ACTIONS_MISSING_SHARE_HOLDER,
      ADMIN_PERMISSIONS.ACTIONS_ROYALTY_SUMMARY_DUPLICATE
    ]
  },
  {
    name: "User Asset",
    href: "/user-asset",
    icon: UserAssetIcon,
    permittedPermissions: [
      ADMIN_PERMISSIONS.USER_ASSET_READ,
      ADMIN_PERMISSIONS.LOGS_USER_LOGS,
      ADMIN_PERMISSIONS.LOGS_CO_MANAGER_LOGS
    ]
  },
  {
    name: "Asset Registry (Releases)",
    href: "/catalog",
    icon: AssetRegistryIcon,
    permittedPermissions: [ADMIN_PERMISSIONS.ASSET_REGISTRY_READ]
  },
  {
    name: "Release Submission",
    href: "/release-submission",
    icon: ReleaseSubmissionIcon,
    permittedPermissions: [ADMIN_PERMISSIONS.RELEASE_SUBMISSION_READ]
  },
  {
    name: "Royalties",
    href: "/royalties",
    icon: RoyaltyReportsIcon,
    permittedPermissions: [ADMIN_PERMISSIONS.ROYALTY_REPORTS_READ]
  },
  {
    name: "Reports Approval",
    href: "/reports-approval",
    icon: ReportsApprovalIcon,
    permittedPermissions: [ADMIN_PERMISSIONS.REPORTS_APPROVAL_READ]
  },
  {
    name: "Reporting",
    href: "/finance-reporting",
    icon: UserAdvanceIcon,
    permittedPermissions: [ADMIN_PERMISSIONS.FINANCE_REPORTING_PL, ADMIN_PERMISSIONS.FINANCE_REPORTING_USER_ADVANCE]
  },
  {
    name: "User Takedown",
    href: "/user-takedown",
    icon: UserTakedownIcon,
    permittedPermissions: [ADMIN_PERMISSIONS.USER_TAKEDOWN_READ]
  },
  {
    name: "State 51 Deliveries",
    href: "/state-51-deliveries",
    icon: State51DeliveryIcon,
    permittedPermissions: [ADMIN_PERMISSIONS.STATE_51_DELIVERIES_READ]
  },
  {
    name: "Scheduler Logs",
    href: "/scheduler-logs",
    icon: SchedulerLogsIcon,
    permittedPermissions: []
  },
  {
    name: "Release Upc / Track ISRC / State51 Batch Id Codes",
    href: "/new-release-codes",
    icon: ReleaseUpcIcon,
    permittedPermissions: [ADMIN_PERMISSIONS.NEW_RELEASE_CODES_READ]
  },
  {
    name: "Playlists",
    href: "/playlists",
    icon: PlaylistIcon,
    permittedPermissions: [ADMIN_PERMISSIONS.PLAYLIST_READ]
  },
  {
    name: "Spotify Charts",
    href: "/spotify-charts",
    icon: SpotifyChartIcon,
    permittedPermissions: [ADMIN_PERMISSIONS.PLAYLIST_READ]
  },
  {
    name: "Insights",
    href: "/trends",
    icon: InsightsIcon,
    permittedPermissions: [ADMIN_PERMISSIONS.ADMIN_INSIGHTS_READ]
  },
  {
    name: "Marketing Milestones",
    href: "/marketing-milestones",
    icon: MarketingIcon,
    permittedPermissions: [ADMIN_PERMISSIONS.ADMIN_INSIGHTS_READ, ADMIN_PERMISSIONS.PLAYLIST_READ]
  },
  {
    name: "Registrations",
    href: "/registrations",
    icon: RegistrationsIcon,
    permittedPermissions: [ADMIN_PERMISSIONS.REGISTRATIONS_READ]
  },
  {
    name: "Territory Dsp List",
    href: "/territory-dsp",
    icon: TerritoryDSPListIcon,
    permittedPermissions: [ADMIN_PERMISSIONS.TERRITORY_DSP_LIST_READ]
  },
  {
    name: "Announcements",
    href: "/announcements",
    icon: AnnouncementsIcon,
    permittedPermissions: [ADMIN_PERMISSIONS.USER_ASSET_READ]
  }
]
